import React, { useState, useEffect } from "react";
import { Routes, Route } from 'react-router-dom';
import './App.css';



function Boulecontainerman() {
  return (
    <div className="App">
     <h3>Homme</h3>
     <div>En construction</div>
     <div>Coming soon</div>
     <img className="en_construction"  src="batiment.gif"/>
    </div>
  );
}

export default Boulecontainerman;
